// /src/components/layout/MainLayout.jsx
// VERSÃO "ESTRATEGISTA IMPERIAL 2.0" - PROTOCOLO TRI-ESTADO

import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import Sidebar from './Sidebar';
import Header from './Header';
import { OrderNotificationProvider } from './OrderNotificationProvider';
import NewOrderPopup from './NewOrderPopup';

export default function MainLayout({ children }) {
  /**
   * ESTADOS DO MENU (sidebarMode):
   * 0: Oculto Completo (Apenas o hambúrguer no Header fica visível e piscando)
   * 1: Mini Menu (Apenas ícones/bolinhas aparecem)
   * 2: Full Menu (Expandido - versão atual)
   */
  const [sidebarMode, setSidebarMode] = useState(2); 
  const navigate = useNavigate();

  // Função Cíclica: 2 -> 1 -> 0 -> (volta para 2 ou conforme sua preferência)
  const toggleSidebar = () => {
    setSidebarMode((prev) => {
      if (prev === 0) return 2; // Do oculto, volta para o cheio
      return prev - 1;          // Vai reduzindo o nível de exposição
    });
  };

  // Validação do token de autenticação (Blindagem de Acesso)
  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) {
      navigate('/login');
    } else {
      try {
        const decodedToken = jwtDecode(token);
        const currentTime = Date.now() / 1000;
        if (decodedToken.exp < currentTime) {
          localStorage.removeItem('token');
          navigate('/login');
        }
      } catch (error) {
        localStorage.removeItem('token');
        navigate('/login');
      }
    }
  }, [navigate]);

  return (
    <OrderNotificationProvider>
      <div 
        className="flex h-screen font-sans transition-all duration-500 overflow-hidden" 
        style={{ backgroundColor: 'var(--bg-main)', color: 'var(--text-primary)' }}
      >
      
      {/* 🛡️ SIDEBAR: Agora recebe o 'mode' em vez de apenas um booleano.
        Passamos também a função para que cliques internos possam resetar o modo se necessário.
      */}
      <Sidebar mode={sidebarMode} setMode={setSidebarMode} />

      <div className="flex-1 flex flex-col min-w-0 overflow-hidden">
        
        {/* 📡 HEADER: O botão hambúrguer aqui deve reagir ao sidebarMode === 0 
          para ativar a animação "piscante".
        */}
        <Header 
          toggleSidebar={toggleSidebar} 
          sidebarMode={sidebarMode} 
        />

        {/* 🚀 ÁREA DE CONTEÚDO 
          Ajustamos o padding/margin dinamicamente baseado no estado do menu 
          para que o conteúdo não fique "esmagado".
        */}
        <main 
          className="flex-1 overflow-x-hidden overflow-y-auto transition-all duration-500 ease-in-out"
          style={{ 
            backgroundColor: 'var(--bg-main)',
            // Adicionamos um leve blur ou overlay se o menu estiver aberto no mobile (opcional)
          }}
        >
          <div className="container mx-auto px-4 sm:px-6 py-8">
            {children}
          </div>
        </main>
      </div>

      {/* Overlay para Mobile (fecha o menu ao clicar fora quando estiver em modo full) */}
      {sidebarMode === 2 && (
        <div 
          className="fixed inset-0 bg-black/50 z-[90] md:hidden backdrop-blur-sm"
          onClick={() => setSidebarMode(0)}
        />
      )}
      <NewOrderPopup />
    </div>
    </OrderNotificationProvider>
  );
}